var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('Header'),_c('el-container',{staticClass:"wrap-80",staticStyle:{"margin":"20px auto"}},[_c('div',{staticClass:"user-center flex"},[_c('Aside',{attrs:{"title":"企业中心"}}),_c('router-view',{key:"mainbox",staticStyle:{"flex":"1"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }